<template>
  <div>
    <loader v-if="is.loading"/>
    <template v-else>
      <header class="entity-detailheader">
        <div class="row align-items-end">
            <div class="col-lg">
                <div v-if="this.procurementMessage.messageType == 'Order'" class="row align-items-end">
                    <div class="col-lg">
                        <dl class="detailheader-list">
                            <dd><h1>{{this.procurementMessage.data.ExternalCorrelationalId}}</h1></dd>
                            <div class="w-100"></div>
                            <dt>Correlational-Id:</dt>
                            <dd>{{this.procurementMessage.data.CorrelationalId}}</dd>
                            <div class="w-100"></div>
                            <dt>Datum:</dt>
                            <dd>{{formatDate(this.procurementMessage.data.OrderDate)}}</dd>
                            <div class="w-100"></div>
                            <dt>Quelle:</dt>
                            <dd>E-Galexis (ProPharma)</dd>
                            <div class="w-100"></div>
                            <dt>Orderid:</dt>
                            <dd>{{this.procurementMessage.data.OrderId}}</dd>
                            <div class="w-100"></div>
                        </dl>
                    </div>
                    <div class="text-right col-lg">
                      <dd><strong>Typ: </strong> <span class="badge orderstate-badge badge-info">{{this.procurementMessage.messageType}}</span></dd>
                        <dd><strong>Status: </strong> <order-state-badge :statename="this.procurementMessage.data.OrderState" :label="this.procurementMessage.data.OrderState" /></dd>
                        <div class="w-100"></div>
                    </div>
                </div>
                <div v-if="this.procurementMessage.messageType == 'DataQueueItem'" class="row align-items-end">
                    <div class="col-lg">
                        <dl class="detailheader-list">
                            <dd><h1>{{this.procurementMessage.data.ExternalId}}</h1></dd>
                            <div class="w-100"></div>
                            <dt>Datum:</dt>
                            <dd>{{formatDate(this.procurementMessage.data.Created)}}</dd>
                            <div class="w-100"></div>
                            <dt>Quelle:</dt>
                            <dd>E-Galexis (ProPharma)</dd>
                            <div class="w-100"></div>
                        </dl>
                    </div>
                    <div class="text-right col-lg">
                      <dd><strong>Typ: </strong> <span class="badge orderstate-badge badge-info">{{this.procurementMessage.messageType}}</span></dd>
                        <dd v-if="this.procurementMessage.data.Message">
                          <strong>Status: </strong> <b-badge variant="danger">Fehlgeschlagen</b-badge>
                        </dd>
                        <dd v-else><strong>Status: </strong> <b-badge variant="warning">Neu</b-badge></dd>
                        <div class="w-100"></div>
                    </div>
                </div>
            </div>
            <div class="col-lg-auto">
                <dl class="detailheader-list justify-content-between"><!----></dl>
            </div>
        </div>
        <div class="detailheader-separator"></div>
      </header>
      <div v-if="this.procurementMessage.messageType == 'Order'">
        <!-- convert to array -->
        <div v-if="this.procurementMessage.data.UnknownProducts.length  !== 0">
          <h2>Unbekannte Produkte</h2>
          <p>Diese Produkte wurden geordert, sind im System aber nicht bekannt</p>
          <ul>
            <li v-for="product in this.procurementMessage.data.UnknownProducts" :key="product">
              {{ product.Quanity }} x {{ product.Id }}
            </li>
          </ul>
        </div>
        <h2>Gesendete XML-Message</h2>
         <pre>{{ formatXml(this.procurementMessage.data.OriginalProcurementMessage) }}</pre>
      </div>
      <div v-if="this.procurementMessage.messageType == 'DataQueueItem'">
        <div v-if="this.procurementMessage.data.Message">
          <h2>Fehlermeldung</h2>
          <b-alert variant="warning" show>{{this.procurementMessage.data.Message}}</b-alert>
        </div>
        <h2>Gesendete XML-Message</h2>
         <pre>{{ formatXml(this.procurementMessage.data.Data.XmlData) }}</pre>
      </div>
    </template>

  </div>
</template>

<script>
import MixinEntityBase from '@/components/mixins/EntityBase'
import { valueFormatter } from '@/assets/js/helper/entity'
import Loader from '@/components/Loader'
import vkbeautify from 'vkbeautify'
import OrderStateBadge from '../../components/order/OrderStateBadge.vue'

import moment from 'moment'

export default {
  name: 'ProcurementMessages.Detail',
  mixins: [MixinEntityBase],
  components: {
    Loader,
    OrderStateBadge
  },
  computed: {
    is () {
      return this.$store.getters[`${this.eParent.key}/is`]
    },
    entity () {
      return this.$store.getters[`${this.eParent.key}/getEntityUnwrapped`](this.eParent.id) || {}
    },
    procurementMessage () {
      return this.$store.getters['procurementmessages/getProcurementMessage']
    }
  },
  methods: {
    valueFormatter,
    getProcurementMessage () {
      this.$store.dispatch('procurementmessages/loadProcurementMessage', {
        id: this.eParent.id
      }).finally(() => {
        this.isLoading = false
      })
    },
    formatXml (xml) {
      return vkbeautify.xml(xml)
    },
    formatDate (date) {
      return moment(new Date(date)).format('DD.MM.YYYY, HH:mm:ss')
    }
  },
  mounted () {
    this.getProcurementMessage()
  }
}
</script>

<style lang="scss">
$entity-header-bottom-gap: $spacer * 1.4 !default;

$entity-header-separator-y-gap: $spacer * 0.8 !default;
$entity-header-separator-height: 5px !default;
$entity-header-separator-bg: $dark !default;

.entity-detailheader {
  margin-bottom: $entity-header-bottom-gap;

  .detailheader-list {
    display: flex;
    flex-wrap: wrap;
    margin: 0;

    > dt {
      margin-right: $spacer;
    }

    > dd {
      margin: 0;

      h1, .h1, h2, .h2, h3, .h3, h4, .h4, h5, .h5, h6, .h6 {
        margin: 0;
      }
    }
  }

  .detailheader-separator {
    margin-top: $entity-header-separator-y-gap;
    height: $entity-header-separator-height;
    background-color: $entity-header-separator-bg;
  }
}
</style>
